import dayjs from 'dayjs'
import i18n from '@/i18n'

export function getTirOptions(data, myChart) {
  return {
    title: {
      show: false
    },
    animation: false,
    series: [
      {
        type: 'pie',
        radius: [20, 60],
        left: 'center',
        width: 350,
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1,
          color: ({ seriesIndex, dataIndex, data, value }) => {
            return ['#F59A24', '#FFFD01', '#0E9A33', '#E56363', '#CC5858'][data.index]
          }
        },
        label: {
          alignTo: 'edge',
          // formatter: `{name|{b}}\n{time|{c} ${i18n.tc('unit.hours')}}`,
          formatter: (parmas) => {
            return `{name|${parmas.name}}\n{time|${parmas.data.timeStr} ${i18n.tc('unit.hours')}}`
          },
          minMargin: 5,
          edgeDistance: 10,
          lineHeight: 15,
          fontSize: 11,
          overflow: 'none',
          rich: {
            time: {
              fontSize: 10,
              color: '#999'
            }
          }
        },
        labelLine: {
          length: 5,
          length2: 0,
          maxSurfaceAngle: 80
        },
        labelLayout: function (params) {
          const isLeft = params.labelRect.x < myChart.getWidth() / 2
          const points = params.labelLinePoints
          // Update the end point.
          points[2][0] = isLeft
            ? params.labelRect.x
            : params.labelRect.x + params.labelRect.width
          return {
            labelLinePoints: points
          }
        },
        data: data
      }
    ]
  }
}

export function getAgpOptions(
  data_10 = [],
  data_25 = [],
  data_50 = [],
  data_75 = [],
  data_90 = [],
  isMgDl = false,
  hyper = 10,
  hypo = 3.9,
  isToB = true
) {
  const intervalTime = data_10.length === 1440 ? 1 : 5
  const marklineObj = {
    symbol: 'none',
    data: [
      {
        silent: false, // 鼠标悬停事件  true没有，false有
        lineStyle: {
          type: 'dashed',
          color: '#ffaf00',
          width: 1
        },
        label: {
          show: isToB,
          formatter: `${i18n.t('unit.high')}`,
          distance: isMgDl ? [30, 0] : [27, 0]
        },
        yAxis: isMgDl ? (hyper * 18).toFixed(1) : hyper // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
      },
      {
        silent: false, // 鼠标悬停事件  true没有，false有
        lineStyle: {
          type: 'dashed',
          color: '#d4001a',
          width: 1
        },
        label: {
          show: isToB,
          formatter: `${i18n.t('unit.low')}`,
          distance: isMgDl ? [30, 0] : [27, 0]
        },
        yAxis: isMgDl ? (hypo * 18).toFixed(1) : hypo
      }
    ]
  }

  return {
    tooltip: {
      show: false,
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    grid: {
      x: isToB ? 20 : 75,
      y: 30,
      x2: isToB ? 100 : 20,
      y2: 30
    },
    xAxis: [
      {
        boundaryGap: false,
        type: 'time',
        splitLine: {
          show: false
        },
        min: +dayjs().startOf('day'),
        max: +dayjs().add(1, 'day').startOf('day'),
        splitNumber: 8,
        axisLabel: {
          showMaxLabel: true,
          formatter: function (value) {
            return dayjs(value).format('HH:mm')
          }
        }
      }
    ],
    yAxis: [
      {
        axisLine: {
          show: true
        },
        type: 'value',
        position: isToB ? 'right' : 'left',
        min: 0,
        max: isMgDl ? 450 : 25,
        interval: isMgDl ? 90 : 5
      }
    ],
    title: {
      subtext: isMgDl ? i18n.tc('unit.mgdL') : i18n.tc('unit.mmolL'),
      right: isToB ? 16 : 'auto',
      left: isToB ? 'auto' : -4,
      top: 9
    },
    animation: false,
    series: [
      {
        z: -1,
        name: '10%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        markLine: marklineObj,
        areaStyle: {
          opacity: 1,
          color: 'white'
        },
        data: data_10.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -2,
        name: '25%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        areaStyle: {
          opacity: 1,
          color: '#d2e1f2'
        },
        // markLine: marklineObj,
        data: data_25.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -3,
        name: '50%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 2,
          color: '#05367f'
        },
        areaStyle: {
          opacity: 1,
          color: '#7fa2d4'
        },
        showSymbol: false,
        // markLine: marklineObj,
        data: data_50.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -5,
        name: '75%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        areaStyle: {
          opacity: 1,
          color: '#7fa2d4'
        },
        // markLine: marklineObj,
        data: data_75.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -6,
        name: '90%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        label: {
          show: true,
          position: 'top'
        },
        areaStyle: {
          opacity: 1,
          color: '#d2e1f2'
        },
        // markLine: marklineObj,
        data: data_90.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      }
    ]
  }
}

export function getGluOptions(
  data = [],
  index,
  date,
  event = [],
  isMgDl = false,
  hyper = 10,
  hypo = 3.9,
  isToB = true
) {
  const intervalTime = data.length === 1440 ? 1 : 5
  const dayStr = dayjs(date)
    .add(index, 'day')
    .startOf('day')
    .format('YYYY-MM-DD')
  event = event[dayStr] || []
  // event = event.slice(0, 10)
  let memIndex = []
  return {
    tooltip: {
      trigger: 'axis',
      show: false
    },
    xAxis: [
      {
        boundaryGap: false,
        type: 'time',
        splitLine: {
          show: false
        },
        min: +dayjs(date).add(index, 'day').startOf('day'),
        max: +dayjs(date)
          .add(index + 1, 'day')
          .startOf('day'),
        splitNumber: 8,
        axisLabel: {
          showMaxLabel: true,
          formatter: function (value) {
            return dayjs(value).format('HH:mm')
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        min: 0,
        max: isMgDl ? 450 : 25,
        interval: isMgDl ? 90 : 5,
        splitNumber: 4,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#DDD'
          }
        },
        position: isToB ? 'right' : 'left',
        axisTick: {
          show: false
        },
        axisLine: {
          show: true
        },
        axisLabel: {
          show: true
        },
        // name: "mmol/L",
        // nameLocation: "middle",
        // nameGap: 30,
        // nameTextStyle: {
        //   fontWight: "bold",
        // },
        splitArea: {
          show: false
        }
      }
    ],
    title: {
      subtext: isMgDl ? i18n.tc('unit.mgdL') : i18n.tc('unit.mmolL'),
      right: isToB ? 16 : 'auto',
      left: isToB ? 'auto' : -4,
      top: -11
    },
    grid: {
      x: isToB ? 20 : 75,
      y: 10,
      x2: isToB ? 100 : 20,
      y2: 30
    },
    animation: false,
    series: [
      {
        name: '血糖值',
        type: 'line',
        data: data.map((c, i) => [
          +dayjs(date)
            .add(index, 'day')
            .startOf('day')
            .add(intervalTime * i, 'minute'),
          c || undefined
        ]),
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true,
        markPoint: {
          symbolSize: 20,
          symbolKeepAspect: true,
          symbolOffset: [0, -10],
          itemStyle: {
            borderWidth: 0
            // color: "red",
          },
          data: event.map((item, eventIndex) => {
            const eventType = item.eventType
            let symbol = 'pin'
            const color = '#000'
            if (eventType === 1) {
              symbol =
                'image://data:image/png;base64,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'
              // color = "#c74e4e";
            } else if (eventType === 2) {
              symbol =
                'image://data:image/png;base64,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'
              // color = "#3c71ff";
            } else if (eventType === 3) {
              symbol =
                'image://data:image/png;base64,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'
              // color = "#64b9b9";
            } else if (eventType === 4) {
              symbol =
                'image://data:image/png;base64,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'
              // color = "#019714";
            }
            const xAxis =
              (+dayjs(item.eventTime) -
                +dayjs(date).add(index, 'day').startOf('day')) /
              (60 * 60 * 24 * 1000)

            let xIndex = Math.floor(data.length * xAxis)
            //  相差太近进行偏移
            memIndex.push(xIndex)
            if (
              eventIndex !== 0 &&
              memIndex[eventIndex] - memIndex[eventIndex - 1] < 3
            ) {
              xIndex = Math.min(data.length - 1, xIndex + 2)
            }
            if (eventIndex === event.length - 1) {
              memIndex = []
            }

            return {
              coord: [
                +dayjs(date)
                  .add(index, 'day')
                  .startOf('day')
                  .add(intervalTime * xIndex, 'minute'),
                data[xIndex]
              ],
              symbol,
              itemStyle: {
                color
              }
            }
          })
        },
        markLine: {
          symbol: 'none',
          data: [
            {
              silent: false, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: '#ffaf00',
                width: 1
              },
              label: {
                show: isToB,
                formatter: `${i18n.t('unit.high')}`,
                distance: isMgDl ? [30, 0] : [27, 0]
              },
              yAxis: isMgDl ? (hyper * 18).toFixed(1) : hyper // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            },
            {
              silent: false, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: '#ff0000',
                width: 1
              },
              label: {
                show: isToB,
                formatter: `${i18n.t('unit.low')}`,
                distance: isMgDl ? [30, 0] : [27, 0]
              },
              yAxis: isMgDl ? (hypo * 18).toFixed(1) : hypo
            }
          ]
        }
      }
    ],
    visualMap: {
      show: false,
      pieces: [
        {
          gte: 0,
          lte: isMgDl ? +(hypo * 18).toFixed(1) : +hypo,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#d4001a'
        },
        {
          gt: isMgDl ? +(hypo * 18).toFixed(1) : +hypo,
          lte: isMgDl ? +(hyper * 18).toFixed(1) : +hyper,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#59c4ea'
        },
        {
          gt: isMgDl ? +(hyper * 18).toFixed(1) : +hyper,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#ffaf00'
        }
      ]
    }
  }
}

export function getMiniGluOptions(data = [], index, date, isMgDl = false, hyper = 10, hypo = 3.9) {
  const intervalTime = data.length === 1440 ? 1 : 5
  return {
    tooltip: {
      trigger: 'axis',
      show: false
    },
    xAxis: [
      {
        boundaryGap: false,
        type: 'time',
        show: false,
        splitLine: {
          show: false
        },
        min: +dayjs(date).add(index, 'day').startOf('day'),
        max: +dayjs(date)
          .add(index + 1, 'day')
          .startOf('day'),
        splitNumber: 8,
        axisLabel: {
          showMaxLabel: true,
          formatter: function (value) {
            return dayjs(value).format('HH:mm')
          }
        }
      }
    ],
    yAxis: [
      {
        // show: false,
        type: 'value',
        min: 0,
        max: isMgDl ? 450 : 25,
        interval: isMgDl ? 90 : 5,
        splitNumber: 4,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#DDD'
          }
        },
        position: 'right',
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        // name: "mmol/L",
        // nameLocation: "middle",
        // nameGap: 30,
        // nameTextStyle: {
        //   fontWight: "bold",
        // },
        splitArea: {
          show: false
        }
      }
    ],
    title: {
      subtext: i18n.tc('unit.mmolL'),
      right: -2,
      top: -11,
      show: false
    },
    grid: {
      x: 0,
      y: 10,
      x2: 0,
      y2: 10
    },
    animation: false,
    series: [
      {
        name: '血糖值',
        type: 'line',
        data: data.map((c, i) => [
          +dayjs(date)
            .add(index, 'day')
            .startOf('day')
            .add(intervalTime * i, 'minute'),
          c || undefined
        ]),
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true,
        markLine: {
          symbol: 'none',
          data: [
            {
              silent: false, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: '#ffaf00',
                width: 1
              },
              label: {
                show: false
              },
              yAxis: isMgDl ? (hyper * 18).toFixed(1) : hyper // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            },
            {
              silent: false, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: '#ff0000',
                width: 1
              },
              label: {
                show: false
              },
              yAxis: isMgDl ? (hypo * 18).toFixed(1) : hypo
            }
          ]
        }
      }
    ],
    visualMap: {
      show: false,
      pieces: [
        {
          gte: 0,
          lte: isMgDl ? +(hypo * 18).toFixed(1) : +hypo,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#d4001a'
        },
        {
          gt: isMgDl ? +(hypo * 18).toFixed(1) : +hypo,
          lte: isMgDl ? +(hyper * 18).toFixed(1) : +hyper,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#59c4ea'
        },
        {
          gt: isMgDl ? +(hyper * 18).toFixed(1) : +hyper,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#ffaf00'
        }
      ]
    }
  }
}

export function getMultiGluChartOptions(data = [], beginDate, isMgDl = false, isToB = true) {
  const intervalTime = data.length > 0 ? (data[0].length === 1440 ? 1 : 5) : 5
  return {
    tooltip: {
      trigger: 'axis',
      show: false
    },
    legend: {
      show: !isToB,
      bottom: 0,
      left: isToB ? 0 : 50,
      icon: 'rect'
    },
    xAxis: [
      {
        boundaryGap: false,
        type: 'time',
        splitLine: {
          show: false
        },
        min: +dayjs().startOf('day'),
        max: +dayjs().add(1, 'day').startOf('day'),
        splitNumber: 8,
        axisLabel: {
          showMaxLabel: true,
          formatter: function (value) {
            return dayjs(value).format('HH:mm')
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        splitNumber: 4,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#DDD'
          }
        },
        min: 0,
        max: isMgDl ? 450 : 25,
        interval: isMgDl ? 90 : 5,
        position: isToB ? 'right' : 'left',
        axisTick: {
          show: false
        },
        axisLine: {
          show: true
        },
        axisLabel: {
          show: true
        },
        // name: isMgDl ? 'mg/dL' : 'mmol/L',
        // nameLocation: "middle",
        nameGap: 30,
        nameTextStyle: {
          fontWight: 'bold'
        },
        splitArea: {
          show: false
        }
      }
    ],
    title: {
      subtext: isMgDl ? i18n.tc('unit.mgdL') : i18n.tc('unit.mmolL'),
      right: isToB ? -2 : 'auto',
      left: isToB ? 'auto' : -4,
      top: -11
    },
    grid: {
      x: isToB ? 20 : 75,
      y: 10,
      x2: isToB ? 80 : 20,
      y2: 95
    },
    animation: false,
    series: data.map((item, index) => {
      return {
        name: dayjs(beginDate).add(index, 'day').format('YYYY-MM-DD'),
        type: 'line',
        data: item.map((c, i) => [
          +dayjs()
            .startOf('day')
            .add(intervalTime * i, 'minute'),
          c || undefined
        ]),
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true
      }
    })
  }
}

export function getPentagonChartOptions(data = {}) {
  const mapping = {
    TOR: data.tor,
    MBG: data.mbg,
    'Intensity HYPER': data.intHyper,
    'Intensity HYPO': data.intHypo,
    CV: data.cv
  }
  return {
    radiusAxis: {
      show: false
    },
    grid: {
      x: 20,
      y: 20,
      x2: 20,
      y2: 20
    },
    radar: {
      axisNameGap: 5,
      axisName: {
        formatter: function (value, indicator) {
          if (mapping[value] || mapping[value] === 0) {
            let cookVal = value.split(' ')
            cookVal =
              cookVal.length === 2 ? `${cookVal[0]}\n${cookVal[1]}` : value
            const displayVal = Number.isInteger(mapping[value])
              ? mapping[value]
              : mapping[value].toFixed(1)
            return `${cookVal}(${displayVal})`
          } else {
            return value
          }
        }
      },
      axisLine: {
        lineStyle: {
          color: '#000'
        }
      },
      axisTick: {
        show: false,
        length: 3
      },
      axisLabel: {
        showMaxLabel: false,
        showMinLabel: false
      },
      splitNumber: 76,
      z: 10,
      shape: 'polygon',
      center: ['50%', '50%'],
      radius: '80%',
      scale: false,
      indicator: [
        {
          name: 'TOR',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 14) {
                return 0
              } else if (value === 40) {
                return 1300
              } else if (value === 50) {
                return 1600
              } else if (value === 30) {
                return 1000
              }
            }
          }
        },
        {
          name: 'MBG',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 14) {
                return 90
              } else if (value === 30) {
                return 220
              } else if (value === 60) {
                return 290
              } else if (value === 44) {
                return 260
              }
            }
          },
          axisTick: {
            // show: false
          }
        },
        {
          name: 'Intensity HYPER',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 14) {
                return 0
              } else if (value === 31) {
                return 60000
              } else if (value === 42) {
                return 80000
              } else if (value === 60) {
                return 110000
              }
            }
          }
        },
        {
          name: 'Intensity HYPO',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 14) {
                return 0
              } else if (value === 28) {
                return 4800
              } else if (value === 36) {
                return 5500
              } else if (value === 52) {
                return 6400
              }
            }
          }
        },
        {
          name: 'CV',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 17) {
                return 14
              } else if (value === 30) {
                return 25
              } else if (value === 45) {
                return 40
              } else if (value === 66) {
                return 60
              }
            }
          }
        }
      ],
      splitArea: {
        show: false
      },
      splitLine: {
        show: false
        // lineStyle: {
        //   color: ["#fff", "#fff", "#fff", "#fff", "#fff", "#000"],
        // },
      }
    },
    polar: {},
    angleAxis: {
      show: false
    },
    animation: false,
    series: [
      {
        name: 'name_1',
        type: 'radar',
        z: 10,
        // colorBy: 'data',
        symbol: 'none',
        lineStyle: {
          width: 1,
          color: '#000'
        },
        data: [
          {
            value: [76, 76, 76, 76, 76]
          }
        ]
      },
      {
        name: 'name_2',
        type: 'radar',
        z: 9,
        areaStyle: {
          opacity: 1,
          color: '#ced686'
        },
        symbol: 'none',
        lineStyle: {
          width: 3,
          color: '#a1101c'
        },
        data: [
          {
            value: [14, 14, 14, 14, 14, 14]
          }
        ]
      },
      {
        name: 'name_3',
        type: 'radar',
        z: 1,
        areaStyle: {
          opacity: 1,
          color: '#b02429'
        },
        symbol: 'none',
        lineStyle: {
          width: 1
        },
        data: [
          {
            value: [
              data.tor_mm,
              data.mbg_mm,
              data.intHyper_mm,
              data.intHypo_mm,
              data.cv_mm
            ]
          }
        ]
      }
    ]
  }
}

export function getDayPentagonChartOptions(data = {}) {
  return {
    radiusAxis: {
      show: false
    },
    grid: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    radar: {
      axisNameGap: 5,
      axisName: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: 'grey'
        }
      },
      axisTick: {
        show: false,
        length: 3
      },
      axisLabel: {
        showMaxLabel: false,
        showMinLabel: false
      },
      splitNumber: 76,
      z: 10,
      shape: 'polygon',
      center: ['50%', '50%'],
      radius: '80%',
      scale: false,
      indicator: [
        {
          name: 'TOR',
          max: 76,
          axisLabel: {
            show: false
          }
        },
        {
          name: 'MBG',
          max: 76,
          axisLabel: {
            show: false
          }
        },
        {
          name: 'Intensity HYPER',
          max: 76,
          axisLabel: {
            show: false
          }
        },
        {
          name: 'Intensity HYPO',
          max: 76,
          axisLabel: {
            show: false
          }
        },
        {
          name: 'CV',
          max: 76,
          axisLabel: {
            show: false
          }
        }
      ],
      splitArea: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    polar: {},
    angleAxis: {
      show: false
    },
    animation: false,
    series: [
      {
        name: 'name_1',
        type: 'radar',
        z: 10,
        // colorBy: 'data',
        symbol: 'none',
        lineStyle: {
          width: 1,
          color: 'grey'
        },
        data: [
          {
            value: [76, 76, 76, 76, 76]
          }
        ]
      },
      {
        name: 'name_2',
        type: 'radar',
        z: 9,
        areaStyle: {
          opacity: 1,
          color: '#ced686'
        },
        symbol: 'none',
        lineStyle: {
          width: 1,
          color: '#000'
        },
        data: [
          {
            value: [14, 14, 14, 14, 14]
          }
        ]
      },
      {
        name: 'name_3',
        type: 'radar',
        z: 1,
        areaStyle: {
          opacity: 0.6,
          color: '#a1101c'
        },
        symbol: 'none',
        lineStyle: {
          width: 0
        },
        data: [
          {
            value: [
              data.tor_mm,
              data.mbg_mm,
              data.intHyper_mm,
              data.intHypo_mm,
              data.cv_mm
            ]
          }
        ]
      }
    ]
  }
}

export function getAreaChartOptions(data = [], beginDate, dayNum) {
  return {
    tooltip: {
      show: false
    },
    title: {
      subtext: 'mm²',
      left: 25,
      top: 0
    },
    legend: {
      show: false
    },
    grid: {
      left: '4%',
      top: 40,
      right: 0,
      // right: "4%",
      bottom: '8%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: new Array(dayNum)
        .fill(0)
        .map((c, i) => i)
        .map((time) =>
          dayjs(beginDate).startOf('day').add(time, 'day').format('MM.DD')
        )
    },
    yAxis: {
      type: 'value'
    },
    animation: false,
    series: [
      {
        name: 'standard',
        type: 'bar',
        stack: 'total',
        color: '#ced686',
        label: {
          show: false
        },
        data: new Array(dayNum).fill(466)
      },
      {
        name: 'area',
        type: 'bar',
        stack: 'total',
        color: '#a1101c',
        label: {
          show: false
        },
        data: data
          .map((c) => c.area)
          .slice(0, dayNum)
          .map((val) => (val <= 466 ? 466 : +val - 466))
      }
    ]
  }
}
